import React from 'react';

export const InvoiceDownloadIcon = ({
  fill = 'none',
  stroke = '#1C452B',
  strokeWidth = 2.98215,
  width = 53,
  height = 53,
  className,
  style,
  innerFill, 
  ...rest
}) => {
  const combinedStyle = {
    width: width,
    height: height,
    minWidth: width,
    minHeight: height,
    flexShrink: 0,
    ...style,
  };
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 53 53"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={combinedStyle}
      {...rest}
    >
      <path
        d="M26.3426 17.6444V32.5551M18.8872 27.5849L26.3426 35.0403L33.7979 27.5849"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.46146 11.4316C3.35505 15.5817 1.49121 20.7508 1.49121 26.3423C1.49121 40.0602 12.6246 51.1936 26.3424 51.1936C40.0603 51.1936 51.1937 40.0602 51.1937 26.3423C51.1937 12.6244 40.0603 1.49109 26.3424 1.49109C22.7887 1.49109 19.3841 2.23663 16.3274 3.60344"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
